import { arcgisToGeoJSON } from '@terraformer/arcgis';
import type { Geometry } from 'arcgis-rest-api';
import type { FeatureGroup, PathOptions } from 'leaflet';
import { featureGroup, circleMarker, geoJSON } from 'leaflet';
import { useEffect, useState } from 'react';
import { useMap } from 'react-leaflet';

import { useAppState } from '@/overmind';
import type { FeatureWithIDs } from '@/overmind/effects/adapters/baseadapter';

const highlightStyle: PathOptions = {
  color: '#2ba3ab',
  fillColor: '#2ba3ab',
  fillOpacity: 0.05,
  weight: 7
};

function useStopHighlightOnGridElementSelected(stopHighlighting: () => void) {
  const selectedFeature = useAppState().selectedFeature;

  useEffect(() => {
    if (!selectedFeature.current) {
      stopHighlighting();
    }
  });
}

export function useHighlightGridElementInMap() {
  const [clickedMarkerLayer, setClickedMarkerLayer] =
    useState<FeatureGroup | null>(null);

  const map = useMap();

  if (!clickedMarkerLayer) {
    setClickedMarkerLayer(featureGroup().addTo(map));
  }

  const highlight = (feature: FeatureWithIDs) => {
    if (clickedMarkerLayer) {
      clickedMarkerLayer.clearLayers();
      const geoJson = arcgisToGeoJSON(feature.geometry as unknown as Geometry);
      geoJSON(geoJson, {
        style: highlightStyle,
        pointToLayer: (_, latLng) => {
          return circleMarker(latLng, highlightStyle);
        }
      }).addTo(clickedMarkerLayer);
    }
  };

  const stopHighlighting = () => {
    clickedMarkerLayer?.clearLayers();
  };

  useStopHighlightOnGridElementSelected(stopHighlighting);

  return { highlight, stopHighlighting };
}
